"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHelpers = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const moment_1 = __importDefault(require("moment"));
class CommonHelpers {
    static booleanToText(value, trueValue, falseValue) {
        const valueToConvert = typeof value === 'string' ? JSON.parse(value) : value;
        return valueToConvert ? trueValue : falseValue;
    }
    static getPrintableDocuments(allDocuments, nonPrintableDocuments) {
        return allDocuments.filter(doc => !nonPrintableDocuments.some(nonPrintDoc => doc.name.includes(nonPrintDoc)));
    }
    static setSessionStorage(key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }
    static getSessionStorage(key) {
        const object = window.sessionStorage.getItem(key);
        if (object) {
            return JSON.parse(object);
        }
        else {
            return null;
        }
    }
    static getRemovedAndAddedDrivers(currentDrivers) {
        const added = [];
        const removed = [];
        const initialDriversList = CommonHelpers.getSessionStorage("initialAdditionalDrivers");
        if (currentDrivers && initialDriversList) {
            const initialDriverSet = new Set(initialDriversList.map((driver) => driver.personId));
            const currentDriverSet = new Set(currentDrivers.map((driver) => driver.personId));
            currentDrivers.forEach((driver, index) => {
                if (!initialDriverSet.has(driver.personId)) {
                    added.push((0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, index < currentDrivers.length - 1 ? ', ' : ''] }));
                }
            });
            initialDriversList.forEach((driver, index) => {
                if (!currentDriverSet.has(driver.personId)) {
                    removed.push((0, jsx_runtime_1.jsxs)("span", { children: [driver.firstName, " ", driver.lastName, index < initialDriversList.length - 1 ? ', ' : ''] }));
                }
            });
        }
        return { addedDrivers: added, removedDrivers: removed };
    }
    static getAmountWithoutDecimalDigits(amount) {
        return "£" + new Intl.NumberFormat('en-UK', { maximumFractionDigits: 0 }).format(amount);
    }
    static getPolicyHolderFullName(interaction) {
        return interaction.policyHolder.firstName + " " + interaction.policyHolder.lastName;
    }
    static getDate(environmentVariable) {
        const date = (0, moment_1.default)(environmentVariable);
        if (!date.isValid()) {
            throw new Error("Invalid date format. Expected YYYY-MM-DD: " + environmentVariable);
        }
        return date.toDate();
    }
}
exports.CommonHelpers = CommonHelpers;
//# sourceMappingURL=CommonHelpers.js.map